import { IconProps } from '../types';

/**
 * -----------------------------------------------------------------------------
 * Renders the X Twitter icon.
 */
export function XTwitterIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <path
        d="
          M3.06433 3L9.98131 12.8276L2.99988 21H4.87488L10.828 14.0303L15.7323
          21H21.6855L14.0917 10.21L20.2499 3H18.3749L13.245 9.00731L9.01745
          3H3.06433ZM5.93542 4.5H8.23376L18.8143 19.4999H16.516L5.93542 4.5Z
        "
        strokeWidth="0.2"
      />
    </svg>
  );
}
